import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import TextField from '@material-ui/core/TextField'
import DragAndDrop from '../Common/dragAndDrop'
import DialogRubroContainer from '../../containers/Rubro/dialogRubro'
import './catalogo.css'
import CropperModal from '../CropperModal'

class Catalogo extends React.Component {
    constructor(props){
        super(props)

        this.state ={ 
            imgSrc: '',
        }
    }
        
    render() {
       
        return (
            <div className='catalogo'>

                {/* menú superior */}
                <TitleBar 
                    title={this.props.edicion === false ? 'Nuevo Catálogo' : this.props.catalogo.nombre + '- Edición catálogo'} 
                    type='create' 
                    handleOnSave={this.props.handleOnSave} 
                    handleOnCancel={this.props.handleOnCancel} 
                    cancelarButtonLink={this.props.edicion === true ? '/Catalogo/catalogoEdicion/'+ this.props.catalogo.id :'/Catalogo/'}
                />
                
                {this.props.open === true ? <DialogRubroContainer handleCancelButton= {this.props.handleCancelButton} 
                                                                  payloadCatalogo= {this.props.payloadCatalogo} 
                                                                  idCatalogo = {this.props.idCatalogo}/> : ''}
                
               
                
                {/* contenido */}
                <div className='inputGroup'>
                    <Row>
                        <Col md={6} className='inputContainer noMargin'>
                        
                        {this.props.valid !== true ? 
                            <TextField                                
                                label='Nombre'
                                error
                                helperText='Ingrese un nombre válido.'
                                name='nombre'
                                value={this.props.catalogo.nombre}
                                onChange={this.props.handleOnChangeNombre}
                            />
                        :
                            <TextField                               
                                label='Nombre'                                
                                name='nombre'
                                value={this.props.catalogo.nombre}
                                onChange={this.props.handleOnChangeNombre}
                            />
                        }

                        </Col>
                    </Row>
                
                    <Row>
                        <Col md={12} className='inputContainer'>
                        
                            <TextField
                                label='Descripción'
                                name='descripcion'
                                multiline
                                value={this.props.catalogo.descripcion}
                                onChange={this.props.handleOnChangeDescripcion}
                            />

                        </Col>
                    </Row>
                </div>

                <div className='inputGroup'>
                    <Row>
                        <Col md={12}>
                            <DragAndDrop 
                                accept='image/jpeg, image/png'
                                message='Arrastra las imágenes o'
                                handleOnDrop={this.props.handleOnDropFile}
                                multiple={false}
                            />
                        </Col>
                        
                    </Row>
                </div>

                <div className='inputGroup'>
                    {this.props.catalogo.imgSrc !== undefined &&        
                    <Row>                            
                        <Col md={12} style={{textAlign:'center'}}>                                                                                    
                            <div className='catalogoImageContainer'>
                                {this.props.catalogo.imgSrc.PathImagen &&
                                <img alt="" onClick={() => {this.props.handleOnOpenCropperModal()}} src={this.props.catalogo.imgSrc.PathImagen.split(':')[0] === "blob" /*length < 100 */ ? this.props.catalogo.imgSrc.PathImagen : `data:image/ief;base64,` + this.props.catalogo.imgSrc.PathImagen}  />}                           
                            </div>                                                         
                        </Col>
                    </Row>}
                </div>

                {this.props.openModalImagen &&
                    <CropperModal
                        ratio={2 / 3}
                        src={this.props.imagenOriginal}
                        handleOnCloseCropperModal={this.props.handleOnCloseCropperModal}
                        handleOnSaveImagenCortada={this.props.handleOnSaveImagenCortada}
                        open={this.props.openModalImagen}
                        //modalArticulo hace que en el cropper la imagen final se vea como 2/3 // TODO: cambiar nombre para no confundir, ya que ahora es lo mismo para articulo y catalogos, la unica diferencia es con los recortes de talleColor que son cuadrados
                        modalArticulo={true}
                    />
                }

            </div>
        )
    }
}

Catalogo.propTypes = {
    catalogo: PropTypes.object.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnDropFile: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired,
    idCatalogo: PropTypes.number,
    open:PropTypes.object.isRequired,


    openModalImagen:PropTypes.object.isRequired,
    handleOnCloseCropperModal:PropTypes.func.isRequired,
    handleOnOpenCropperModal:PropTypes.func.isRequired,
    handleOnSaveImagenCortada:PropTypes.func.isRequired,
};

export default Catalogo